import { useEffect, useMemo } from 'react'
import { shuffle } from 'lodash'
import { useGetCertificateProgramTiles } from '@mc/api-hooks'
import { addPageAction, trackError } from '@mc/monitoring'
import {
  PAINTED_DOOR_CARD_CONTENT,
  usePaintedDoorV2Enabled,
} from 'pages/certificates/experiments/mccerts-2138-painted-door-v2'

export const useCertificateProgramCatalog = (
  page: 'hub' | 'detail' | 'nav',
) => {
  const { data, isError, isLoading, error } = useGetCertificateProgramTiles()
  const isPaintedDoorV2Enabled = usePaintedDoorV2Enabled()

  useEffect(() => {
    if (isError) {
      trackError(error as Error, { hook: 'useGetCertificateProgramTiles' })
      addPageAction('certificates_below_fold_data_missing', { page })
    }
  }, [isError, error, page])

  const tiles = useMemo(() => {
    const paintedDoorTiles = isPaintedDoorV2Enabled
      ? shuffle(PAINTED_DOOR_CARD_CONTENT)
      : []
    return [...(data?.tiles || []), ...paintedDoorTiles]
  }, [isPaintedDoorV2Enabled, data?.tiles])

  return { tiles, isError, isLoading }
}
